import { Card, Row, Col } from 'react-bootstrap';
import BaseFeature from './BaseFeature';
import { dimmingModes } from '../../../../../../utils/constantValues';
import { DIMMING_MODES } from '../../../../../../utils/constantFeatures';
import PropertyDropdown from './components/PropertyDropdown';

export default class DimmingModes extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[DIMMING_MODES.enable].value === "1" ? true : false
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;

        if (this.getCorrectPropertyName(propertyName) === DIMMING_MODES.enable) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }

        this.props.handleChange(propertyName, v);
    }

    render() {

        const enable = this.props.properties[DIMMING_MODES.enable];

        return (
            <div className="flex-row">
                <Card className={this.getClassName([enable])}>
                    <div className="card-header-feature">
                        {'Low-Level Dimming Mode'}
                    </div>
                    <Card.Body className="card-body-feature" >
                        {enable.valueMeta.max === "0" ? (
                            <Row>
                                <Col sm={6}>{'Dimming Mode'}</Col>
                                <Col sm={6}>{dimmingModes[0].value}</Col>
                            </Row>
                        ) : (
                            <PropertyDropdown
                                title={'Dimming Mode'}
                                property={enable}
                                propertyDisplayFunc={(res) => res}
                                properties={dimmingModes}
                                handleChange={this.handleChange} />
                        )}
                    </Card.Body>
                </Card>
            </div>
        );
    }
}
